module.exports = __webpack_public_path__ + "static/blockchain-5903a1d6e51e1edaae682ad23087b142.svg";